import React from "react";
import { SkitsOlympicLogoIcon } from "../icons";
import "./footer.scss";

function Footer() {
  return (
    <div id="footer">
      {/* <div className="footer-links">
        <a href="#about">About</a>
        <a href="#contact">Contact</a>
        <a href="#faq">Faq</a>
        <a href="#terms">Terms</a>
        <a href="#privacy">Privacy</a>
      </div> */}
      <p className="siteOwner">A Laura Phipps production</p>
         {/* logo + ® for your registered icon */}
         <p className="logo-text">
        <SkitsOlympicLogoIcon
          fillColor="var(--color-darkGold)"
          width="20px"
          height="20px"
        />
        <span className="registered">®</span>
        Skitsicon<span className="pending">™</span>{" "}
        <span className="copyright copyRightName">© 2023</span>

      </p>

      {/* name pending ™ and then © for your site content */}
      <p className="">
      </p>
    </div>
  );
}

export default Footer;
